import styled, { css } from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import { jsx as _jsx } from "react/jsx-runtime";
const breadcrumbTextStyles = css(["&&&{font-size:14px;}"]);
const Breadcrumbs = styled(UIBreadcrumbs).withConfig({
  displayName: "DocsBreadcrumbs__Breadcrumbs",
  componentId: "q4x7he-0"
})(["&&{margin:8px 0 16px;}"]);
const BreadcrumbLink = styled(UIRouterLink).withConfig({
  displayName: "DocsBreadcrumbs__BreadcrumbLink",
  componentId: "q4x7he-1"
})(["", " font-weight:normal;"], breadcrumbTextStyles);
const BreadcrumbSpan = styled.span.withConfig({
  displayName: "DocsBreadcrumbs__BreadcrumbSpan",
  componentId: "q4x7he-2"
})(["", ""], breadcrumbTextStyles);

/**
 * Renders the breadcrumbs on MDX docs (a.k.a. human-authored docs) and endpoint
 * routes.
 */
export default function DocsBreadcrumbs({
  breadcrumbs
}) {
  if (!breadcrumbs) return null;
  return /*#__PURE__*/_jsx(Breadcrumbs, {
    flush: true,
    children: breadcrumbs.map((breadcrumb, i) => breadcrumb.link ? /*#__PURE__*/_jsx(BreadcrumbLink, {
      to: breadcrumb.link,
      children: breadcrumb.name
    }, i) : /*#__PURE__*/_jsx(BreadcrumbSpan, {
      children: breadcrumb.name
    }, i))
  });
}